<i class="lederplan-ikon-graduate-cap"></i>
<div class="innhold">
  <ng-content/>
</div>
